import { useContext, useState } from "react";
import EmojiPicker from "emoji-picker-react";
import Draggable from "react-draggable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAt, faChevronCircleDown, faFileAlt, faPaperclip, faSearch, faTags, faTimes } from "@fortawesome/free-solid-svg-icons";
import JoditTextEditor from "../../common/JoditEditor/JoditTextEditor";
import { AppDataRequired } from "../../App";
import AppContext from '../../Context/AppContext';
import { useSelector } from "react-redux";
import { CCollapse } from "@coreui/react";
import { OtsideClickClosingWrapper } from "../EmojiReactionPicker/OtsideClickClosingWrapper";
import { Input } from "reactstrap";
const CommentEditor = ({
  showEditorPopover,
  setShowEditorPopover,
  replyTo,
  setReplyTo,
  commentInput,
  setCommentInput,
  saveCommentForTask,
  messageBehavior,
  messageBehaviorRef,
  isFromNotes,
  action,
  editorType,
  chatContainerRef,
  setscrollToEnd,
  scrollToEnd,
  setAttachments,
  attachments,
  selectUser,
  setshowAttchments,
  showAttchments
}) => {
 let allDealsAndUsers = useSelector((state) => state.AppReduxContext.AllDeals || []);
 const AppData = useContext(AppContext);
 const { state, dispatch } = AppData || {};
 const allAccounts = state.AllAccounts || [];
 const { AllUsers } = useContext(AppDataRequired);
 const [showEmojiPicker, setShowEmojiPicker] = useState(false);
 const [showMentionList, setShowMentionList] = useState(false);
 const [tagType, setTagType] = useState("main");
 const [showTagList, setShowTagList] = useState(false);
 const [accountSearch, setAccountSearch] = useState("");
 const [dealsSearch, setDealsSearch] = useState("");
  const getUserNameByEmail = (email) => {
    const user = AllUsers.find((u) => u.email === email);
    return user?.full_name || email;
  };
  const filteredAccounts = allAccounts.filter(acc =>
    acc.Account_Name?.toLowerCase().includes(accountSearch.toLowerCase())
  );
  const filteredDeals = allDealsAndUsers.filter(deal =>
    deal.Deal_Name?.toLowerCase().includes(dealsSearch.toLowerCase())
  );
  const [visible, setVisible] = useState(false);
  const truncateMessage = (html, maxLength) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";

    return text.length > maxLength
      ? text.slice(0, maxLength) + "..."
      : text;
  };

  if (!showEditorPopover) return null;
  const replaceLastHashWithTag = (prev, value) => {
    const lastHashIndex = prev.lastIndexOf("#");

    if (lastHashIndex !== -1) {
        return (
        prev.substring(0, lastHashIndex) +
        `<a href="">${value}</a> `
        );
    }

    return prev + `<a href="">${value}</a> `;
    };

  const getUserThumbnailUrl = (zuid) => "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";
  return (
    <Draggable /*handle=".drag-handle"*/ cancel=".editor-container">
        <div
        style={{
            position: (editorType == "Notes" || editorType == "Chat" ||  editorType == "Comment")?"fixed":"absolute",
            left: editorType == "Notes"?"35rem":"7k",
            bottom: editorType == "Notes"?"7rem":editorType == "Chat"?"4rem":editorType == "Comment"?"4.5rem":"-6px",
            // bottom: "1.5rem",
            // right: "17rem",
            width: editorType == "Chat"?"549px":editorType == "Comment"?"602px":"565px",
            maxWidth: "90vw",
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            padding: "12px",
            zIndex: 9999,
        }}
        >
        <div style={{
            position: "sticky",
            top: 0,
            marginLeft: "14px",
            marginRight: "8px",
            background: "linear-gradient(135deg,#0181cb,#0199f0)",
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            padding: "3px 16px",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
            letterSpacing: "0.3px"
        }}>{editorType == "CommentList"?"Comment":editorType} Editor</div>
            
            {attachments?.length > 0 && !showAttchments && (
                <div
                    className="Attachment-Btn"
                    onClick={(e) => { setshowAttchments(true);}}
                >
                    <span>{`Attachments (${attachments?.length})`}</span>
                    <FontAwesomeIcon icon={faAngleUp} />
                </div>
            )}
        
        {replyTo && (
            <div style={{
            background: "#e9edef",
            padding: "5px 12px",
            marginLeft: '14px',
            marginRight: '7px',
            borderLeft: "4px solid #25D366",
            fontSize: "13px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
            }}>
                <div>
                <div style={{ fontWeight: "600", fontSize: "12px" }}>
                    Replying to {replyTo?.sender ? replyTo?.sender?.name : getUserNameByEmail(replyTo.CREATEDBY)}
                </div>

                {replyTo?.content?.thumbnail?.blur_data &&
                    replyTo?.content?.file?.type?.includes("image") && (
                    <img
                        src={`data:image/png;base64,${replyTo?.content?.thumbnail?.blur_data}`}
                        style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "6px", marginTop: "4px" }}
                    />
                )}

                {(replyTo?.Message || replyTo?.content?.text) && (
                    <div>
                        {truncateMessage(replyTo?.Message ? replyTo?.Message : replyTo?.content?.text, 60)}
                    </div>
                )}
                </div>
                <span
                style={{ cursor: "pointer", fontWeight: "bold" }}
                onClick={() => setReplyTo(null)}
                >
                ✕
                </span>
            </div>
            )}
        <div className="editor-container">
            <JoditTextEditor
            id="comment"
            joditClass="jodit-comment-editor small-editor"
            commentContent={commentInput}
            setEmailContent={(content) => setCommentInput(content)}
            signature="NoSignature"
            allUsers={AllUsers}
            saveCommentForTask={(value) => {
                saveCommentForTask(value);
                setShowEditorPopover(false);
            }}
            messageBehavior={messageBehavior}
            taskCommenRef={messageBehaviorRef}
            setShowTagList = {(val) => setShowTagList(val)}
            setShowMentionList = {(val) => setShowMentionList(val)}
            />
            {showMentionList && (
            <div className="mention-dropdown">
            
                {AllUsers.map((user) => (
                <div
                    key={user.id}
                    className="mention-item"
                    onClick={() => {
                        setCommentInput((prev) => {
                            const lastAtIndex = prev.lastIndexOf("@");
                            const mentionTag = `<a href="">${user.full_name}</a> `;
                            if (lastAtIndex !== -1) {
                                return prev.substring(0, lastAtIndex) + mentionTag;
                            }
                            return prev + (prev ? " " : "") + mentionTag;
                        });
                        setShowMentionList(false);
                        }}
                >
                    <img className="User-Image" src={getUserThumbnailUrl(user.zuid)} />
                    {user.full_name}
                </div>
                ))}
            </div>
            )}
            
            {showTagList && (
                <div className="mention-dropdown">

                {tagType === "main" && (
                    <>
                    <div
                        className="mention-item"
                        onClick={() => setTagType("users")}
                    >
                        👤 Users
                        <span className="dropdown-arrow">›</span>
                    </div>

                    <div
                        className="mention-item"
                        onClick={() => setTagType("accounts")}
                    >
                        🏢 Accounts
                        <span className="dropdown-arrow">›</span>
                    </div>

                    <div
                        className="mention-item"
                        onClick={() => setTagType("deals")}
                    >
                        💼 Deals
                        <span className="dropdown-arrow">›</span>
                    </div>
                    </>
                )}

                {tagType === "users" && (
                    <>
                    <div
                        className="mention-back"
                        onClick={() => setTagType("main")}
                    >
                        ← Back
                    </div>

                    {AllUsers.map((user) => (
                        <div
                        key={user.id}
                        className="mention-item"
                        onClick={() => {
                            setCommentInput(
                            (prev) =>  replaceLastHashWithTag(prev, user.full_name)
                            );
                            setShowTagList(false);
                            setTagType("main");
                        }}
                        >
                        <img className="User-Image" src={getUserThumbnailUrl(user.zuid)} />
                        {user.full_name}
                        </div>
                    ))}
                    </>
                )}

                {tagType === "accounts" && (
                    <>
                    <div style={{position:"sticky", top:0, background:"#fff", zIndex:2, paddingLeft:"5px"}}>
                    <div className="mention-back"
                        onClick={() =>{
                        setTagType("main");
                        setAccountSearch("")
                        } }
                    >
                        ← Back
                    </div>
                    <div className="input-search-wrapper"  style={{ position: "relative" }}>
                        <div className="search-icon-wrapper">
                        <FontAwesomeIcon
                            className="mr-sm-2 search-ico"
                            icon={faSearch}
                        />
                        </div>
                        <Input type="text" value={accountSearch}
                            onChange={(e) => setAccountSearch(e.target.value)}
                            placeholder="Search Aaccounts..."
                            className="mr-sm-2 pad-fix search-filter search-deal"
                            style={{
                                width: "17rem",
                                borderColor: "#018EE0",
                                paddingRight: "28px"
                            }}
                        />
                        {accountSearch && (
                            <FontAwesomeIcon
                            icon={faTimes}
                            onClick={() => setAccountSearch("")}
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#999",
                                fontSize: "12px"
                            }}
                            />
                        )}
                    </div>
                    </div>

                    <div style={{maxHeight:"150px", overflowY:"auto"}}>
                    <div className="mention-account-container">
                    {filteredAccounts.map((acc) => (
                            <span
                            key={acc.id}
                            className="account-pill"
                            style={{ background: acc.Color  ? acc.Color :  `#5b6c97` }}
                            onClick={() => {
                                setCommentInput(
                                (prev) => replaceLastHashWithTag(prev, acc.Account_Name)
                                );
                                setShowTagList(false);
                                setTagType("main");
                            }}
                            >
                            {acc.Account_Name}
                            </span>
                    ))}
                    </div>
                    </div>
                    </>
                    )}

                {tagType === "deals" && (
                    <>
                    <div style={{position:"sticky", top:0, background:"#fff", zIndex:2, paddingLeft:"5px"}}>
                    <div
                        className="mention-back"
                        onClick={() => {
                        setTagType("main");
                        setDealsSearch("")
                        }}
                    >
                        ← Back
                    </div>
                    <div className="input-search-wrapper" style={{ position: "relative" }}>
                        <div className="search-icon-wrapper">
                            <FontAwesomeIcon
                            className="mr-sm-2 search-ico"
                            icon={faSearch}
                            />
                        </div>
                        <Input type="text" value={dealsSearch}
                            onChange={(e) => setDealsSearch(e.target.value)}
                            placeholder="Search Deals..."
                            className="mr-sm-2 pad-fix search-filter search-deal"
                            style={{
                            width: "17rem",
                            borderColor: "#018EE0",
                            paddingRight: "28px"
                            }}
                        />

                        {dealsSearch && (
                            <FontAwesomeIcon
                            icon={faTimes}
                            onClick={() => setDealsSearch("")}
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#999",
                                fontSize: "12px"
                            }}
                            />
                        )}
                    </div>
                    </div>

                    <div style={{maxHeight:"150px", overflowY:"auto"}}>
                    <div className="mention-account-container">
                    {filteredDeals.map((deal) => (
                            <span
                            key={deal.id}
                            className="account-pill"
                            style={{ background: `#5b6c97` }}
                            onClick={() => {
                                setCommentInput(
                                (prev) => replaceLastHashWithTag(prev, deal.Deal_Name)
                                );
                                setShowTagList(false);
                                setTagType("main");
                            }}
                            >
                            {deal.Deal_Name}
                            </span>
                    ))}
                    </div>
                    </div>
                    </>
                    )}

                </div>
            )}
        </div>
        {attachments?.length > 0 && showAttchments && (
            <OtsideClickClosingWrapper
                className={`mention-dropdown`}
                close={() => setshowAttchments(false)}
            >
                <CCollapse id="collapseWidthExample" visible={true}>
                <div className="User-Mention-Header">Attachments</div>

                {attachments.map((a) => (
                    <div key={a.name} className="Attachment-Main">
                    <div className="Deal-Account-Wrapper Attachment-Wrapper">
                        <FontAwesomeIcon color="grey" icon={faFileAlt} />
                        <span>{a?.name}</span>
                    </div>

                    <FontAwesomeIcon
                        className="Delete-Icon"
                        icon={faTimes}
                        onClick={() => {
                            const arr = attachments.filter((aa) => aa.name !== a.name);
                            setAttachments(arr);

                            if (arr.length === 0) {
                                setshowAttchments(false);
                            }
                        }}
                    />
                    </div>
                ))}
                </CCollapse>
            </OtsideClickClosingWrapper>
        )}
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "8px",
                paddingLeft: "13px",
                paddingRight: "13px"
            }}
            >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span
                style={{ fontSize: "15px", cursor: "pointer" }}
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                >
                😊
                </span>

                <span
                className="mention-icon"
                onClick={() => setShowMentionList(!showMentionList)}
                >
                <FontAwesomeIcon id="add-mention-user" icon={faAt} />
                </span>

                <span
                onClick={() => setShowTagList(!showTagList)}
                className="mention-icon"
                >
                <FontAwesomeIcon id="add-comment-tag" icon={faTags} />
                </span>
                {editorType == "Chat" && (
                    <span className="mention-icon">
                        <FontAwesomeIcon
                            opacity={chatContainerRef ? 0 : 1}
                            color="#018cdc"
                            className="scroll-down-icon"
                            onClick={(e) => {
                            setscrollToEnd(!scrollToEnd);
                            }}
                            icon={faChevronCircleDown}
                        ></FontAwesomeIcon>
                        <input
                            id="Attachment"
                            onChange={(e) => {
                            let selectedFile = e.currentTarget.files[0];
                            if (attachments?.length > 0) {
                                if (
                                !attachments.find(
                                    (a) => a.name == selectedFile.name
                                )
                                ) {
                                setAttachments([...attachments, selectedFile]);
                                } else {
                                alert("File already selected!");
                                }
                            } else {
                                setAttachments([selectedFile]);
                            }
                            }}
                            type="file"
                            hidden
                        />
                        <FontAwesomeIcon
                            className=""
                            onClick={(e) => {
                            if (!selectUser?.removed) {
                                document.getElementById("Attachment").click();
                            }
                            }}
                            icon={faPaperclip}
                        />
                    </span>
                )}
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span
                style={{
                    fontSize: "15px",
                    cursor: "pointer",
                    color: "#0181cb",
                }}
                onClick={() => {
                    setReplyTo?.("");
                    setShowTagList?.(false);
                    setCommentInput?.("");
                    setShowMentionList?.("");
                    setShowEditorPopover?.(false);
                    setAttachments?.("")
                }}
                >
                Cancel
                </span>

                <span
                style={{
                    fontSize: "15px",
                    cursor: (commentInput.trim() || attachments?.length > 0) ? "pointer" : "not-allowed",
                    color: (commentInput.trim() || attachments?.length > 0) ? "#0181cb" : "#c6c6c6",
                }}
                onClick={() => {
                    saveCommentForTask?.(commentInput, attachments);
                    setShowEditorPopover?.(false);
                    setshowAttchments?.(false);
                }}
                >
                {action == "Edit" ? "Update" : "Send"}
                </span>
            </div>

            {showEmojiPicker && (
                <div style={{ position: "fixed", bottom: "5px", right: "100%", zIndex: 1000 }}>
                <EmojiPicker
                    onEmojiClick={(event, emojiData) => {
                    setCommentInput((prev) => prev + emojiData.emoji);
                    setShowEmojiPicker(false);
                    }}
                />
                </div>
            )}
            </div>
        </div>
    </Draggable>
  );
};

export default CommentEditor;